import { z } from "zod";
import { emailValidator } from "../../../lib/validator/email";

export const LoginFormSchema = z.object({
  email: emailValidator,
  password: z.string().min(1, {
    message: "Password is required",
  }),
});

export type LoginFormSchemaType = z.infer<typeof LoginFormSchema>;
